import { exists } from '@/api'

export interface BatchLendDbUpdateCondition {
  outputMode: string
  dueDateType: string
  dueDate: string
}

export function BatchLendDbUpdateConditionFromJSON(
  json: any
): BatchLendDbUpdateCondition {
  const _json = JSON.parse(json)

  return {
    outputMode: exists(_json, 'output_mode') ? _json.output_mode : '',
    dueDateType: exists(_json, 'due_date_type') ? _json.due_date_type : '1',
    dueDate: exists(_json, 'due_date') ? _json.due_date : ''
  }
}
